import "./DiagonalPhoto.css";

/** Renders the shared responsive diagonal card image, optionally collapsible.
 *  `mirror` flips the photo horizontally (on an inner wrapper, so the diagonal
 *  mask and the hover zoom are untouched), used when the subject sits on the
 *  side the copy panel would otherwise cover. */
export function DiagonalPhoto({ src, srcSet, open, mirror }: { src: string; srcSet?: string; open?: boolean; mirror?: boolean }) {
  const collapsible = open !== undefined;
  const flip = mirror || undefined;
  return (
    <>
      <div className="diagonal-photo__mobile md:hidden" data-collapsible={collapsible} data-open={open} aria-hidden="true">
        <div className="diagonal-photo__flip" data-mirror={flip}>
          <img src={src} srcSet={srcSet} sizes="100vw" alt="" loading="lazy" className="diagonal-photo__image" />
        </div>
      </div>
      <div className="diagonal-photo__desktop" data-collapsible={collapsible} data-open={open}>
        <div className="diagonal-photo__flip" data-mirror={flip}>
          <img src={src} srcSet={srcSet} sizes="(min-width: 80rem) 40rem, 52vw" alt="" loading="lazy" className="media-zoom" />
        </div>
      </div>
    </>
  );
}
